






















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ClearValueButton extends Vue {
  @Prop(Number) readonly value: number | undefined;

  showModifierChip = true

  mouseEnterChipArea() {
    this.showModifierChip = this.value === 0;
  }

  mouseLeaveChipArea() {
    this.showModifierChip = true;
  }
}
